// src/auction-modules.ts
var AuctionType = /* @__PURE__ */ ((AuctionType2) => {
  AuctionType2["SEALED_BID"] = "EMPA";
  AuctionType2["FIXED_PRICE_BATCH"] = "FPBA";
  return AuctionType2;
})(AuctionType || {});
var AuctionDerivativeTypes = /* @__PURE__ */ ((AuctionDerivativeTypes2) => {
  AuctionDerivativeTypes2["LINEAR_VESTING"] = "LIV";
  return AuctionDerivativeTypes2;
})(AuctionDerivativeTypes || {});

// src/callbacks.ts
var CallbacksType = /* @__PURE__ */ ((CallbacksType2) => {
  CallbacksType2["NONE"] = "None";
  CallbacksType2["CUSTOM"] = "Custom";
  CallbacksType2["MERKLE_ALLOWLIST"] = "MerkleAllowlist";
  CallbacksType2["CAPPED_MERKLE_ALLOWLIST"] = "CappedMerkleAllowlist";
  CallbacksType2["ALLOCATED_MERKLE_ALLOWLIST"] = "AllocatedMerkleAllowlist";
  CallbacksType2["TOKEN_ALLOWLIST"] = "TokenAllowlist";
  CallbacksType2["UNIV2_DTL"] = "UniswapV2DirectToLiquidity";
  CallbacksType2["UNIV3_DTL"] = "UniswapV3DirectToLiquidity";
  CallbacksType2["BASELINE"] = "Baseline";
  CallbacksType2["BASELINE_ALLOWLIST"] = "BaselineAllowlist";
  CallbacksType2["BASELINE_ALLOCATED_ALLOWLIST"] = "BaselineAllocatedAllowlist";
  CallbacksType2["BASELINE_CAPPED_ALLOWLIST"] = "BaselineCappedAllowlist";
  CallbacksType2["BASELINE_TOKEN_ALLOWLIST"] = "BaselineTokenAllowlist";
  CallbacksType2["UNIV3_DTL_WITH_ALLOCATED_ALLOWLIST"] = "UniswapV3DirectToLiquidityWithAllocatedAllowlist";
  return CallbacksType2;
})(CallbacksType || {});
var isBaselineCallback = (callbacksType) => {
  return callbacksType === "Baseline" /* BASELINE */ || callbacksType === "BaselineAllowlist" /* BASELINE_ALLOWLIST */ || callbacksType === "BaselineAllocatedAllowlist" /* BASELINE_ALLOCATED_ALLOWLIST */ || callbacksType === "BaselineCappedAllowlist" /* BASELINE_CAPPED_ALLOWLIST */ || callbacksType === "BaselineTokenAllowlist" /* BASELINE_TOKEN_ALLOWLIST */;
};
export {
  AuctionDerivativeTypes,
  AuctionType,
  CallbacksType,
  isBaselineCallback
};
//# sourceMappingURL=index.js.map